<div class="h-100 t2 c-primary-gray-900" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="12px">
    @if (paymentOrderAttachments.length) {
        <mat-expansion-panel class="w-100">
            <mat-expansion-panel-header class="w-100"
                                        fxLayout="start start">
                <mat-panel-title class="no-wrap t2-semi-bold"> {{ 'i18n_af_labelPaymentOrder' | translate }}</mat-panel-title>
            </mat-expansion-panel-header>
            <af-file-group-preview [attachments]="paymentOrderAttachments"/>
        </mat-expansion-panel>
    }
    <mat-expansion-panel class="w-100">
        <mat-expansion-panel-header class="w-100"
                                    fxLayout="start start">
            <mat-panel-title class="no-wrap t2-semi-bold"> {{ 'i18n_af_labelRefundCommonDetails' | translate }}</mat-panel-title>
        </mat-expansion-panel-header>
        <div class="common-info-container">
            @for (field of commonFieldInfo; track field) {
                <div class="t2 c-primary-gray-600"> {{ 'i18n_af_label_field_refund#' + field.fieldName | translate }}</div>
                @if (field.hasClickableItems) {
                    <span class="t2 c-primary-gray-900" fxLayout="row" fxLayoutAlign="start center">
                        @for (expandableField of field.expandableValue; track expandableField; let last = $last; ) {
                            <span class="c-primary-green-800 pointer underlined-text user-no-select"
                                  (click)="expandableField.click()">
                                {{ expandableField.fieldValue }}
                            </span>
                            @if (!last) {
                                ,
                            }
                        }
                    </span>
                } @else {
                    <div class="t2 c-primary-gray-900"> {{ field.fieldValue }}</div>
                }
            }
        </div>
        <div class="mt-40 t2-semi-bold">{{ 'i18n_af_labelAdditionalFiles' | translate }}</div>
        <af-file-group-preview [attachments]="attachments"/>
    </mat-expansion-panel>
    <mat-expansion-panel class="w-100">
        <mat-expansion-panel-header class="w-100"
                                    fxLayout="start start">
            <mat-panel-title class="no-wrap t2-semi-bold"> {{ 'i18n_af_labelRefundTransactionDetails' | translate }}</mat-panel-title>
        </mat-expansion-panel-header>
        <div class="common-info-container">
            @for (field of transactionFieldInfo; track field) {
                <div class="t2 c-primary-gray-600"> {{ 'i18n_af_label_field_refund#' + field.fieldName | translate }}</div>
                <div class="t2 c-primary-gray-900"> {{ field.fieldValue }}</div>
            }
        </div>
        <div class="divider mt-40 w-100"></div>
        <div class="container">
            <af-participant-details [fields]="senderFields" label="i18n_af_labelParticipantSender"/>
            <af-participant-details [fields]="receiverFields" label="i18n_af_labelParticipantReceiver"/>
        </div>
    </mat-expansion-panel>
</div>
